<template>
  <div class="empty-state my-auto d-flex flex-column row-gap-4 px-6">
    <div class="font-weight-bold text--large text-purple-darken-1 text-center">{{ $t(`${TRANSLATION_KEY_PREFIX}.emptyState.title`) }}</div>
    <div>{{ $t(`${TRANSLATION_KEY_PREFIX}.emptyState.content`) }}</div>
    <ul class="px-6">
    <template v-for="item, index in $tm(`${TRANSLATION_KEY_PREFIX}.emptyState.list`)" :key="index">
      <li>{{ item }}</li>
    </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
const TRANSLATION_KEY_PREFIX = 'common.ai-assistant.AIAssistantPane'
</script>